module.exports = __webpack_public_path__ + "static/media/sector-1.0c1cd297.jpg";